module.exports = __webpack_public_path__ + "img/pencil.83945571.svg";